export default __webpack_public_path__ + "static/media/centered.31406da3.png";